
































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import { AppStore } from '@/store/modules/app';
import axios from 'axios';
import request from '@/utils/request';
// import * as Qiniu from 'qiniu-js';
import { upload } from '@/utils/upload';
import AMSDialog from '@/components/AMSDialog.vue';

@Component({
  components: {
    'ams-dialog': AMSDialog
  }
})
export default class AMSUpload extends Vue {
  @Prop({ type: [Array, String] }) value!: Array<any>;
  @Prop({ type: String, default: '*' }) accept!: string;
  @Prop({ type: Boolean }) multiple!: boolean;
  @Prop({ type: Boolean, default: false }) required!: boolean;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop({ type: String }) uploadApi!: string;
  @Prop({ type: Number }) limit!: number; //图片上传限制个数
  @Prop({ type: Boolean, default: true }) isUseForPorduct!: Boolean; //是否是使用在商品图片那边
  @Prop({ type: Number, default: 6 }) maxSize!: number;

  public $refs!: {
    upload_file: HTMLElement;
  };
  profilePictureId: any = '';
  size = 0;
  token = '';
  key = '';
  Limit: number = 1;
  imgSrc: Array<any> | any = this.value;
  showImage: Boolean = false;
  modalTitle: string = '查看图片';
  imgUrl: string = ''; //大图url
  /**用来充值limit数 */
  resetLimit() {
    this.Limit = this.limit;
  }
  showBigImage(pic: string) {
    this.showImage = true;
    this.imgUrl = pic;
  }
  confirmClose() {
    this.showImage = false;
  }

  chooseType() {
    this.$refs.upload_file.click();
  }
  created() {
    this.Limit = this.limit;
  }
  profileUrl(url: any) {
    return `${process.env.VUE_APP_FILE_URL}/${url.pictureKey}`;
  }
  fileChange(el: any) {
    const size = el.target.files[0].size;
    if (size) {
      if (size >= this.maxSize * 1024 * 1024) {
        AppStore.ShowError(`图片大小在${this.maxSize}M以内`);
        return;
      }
    } else {
      AppStore.ShowError(`图片大小在${this.maxSize}M以内`);
      return;
    }

    let file = el.target.files[0];

    /**判断文件类型 */
    const types = this.accept.split(',');
    const name: string = file.name;
    const type = name.substring(name.lastIndexOf('.'));
    if (types.indexOf(type) == -1) {
      AppStore.ShowError(`请选择正确格式的文件`);
      return;
    }

    el.target.value = '';
    if (this.Limit !== undefined) this.Limit--;
    if (this.Limit !== undefined && this.Limit < 0) return;
    const self = this;

    // 上传图片
    upload(file, 'name').then((key) => {
      self.imgSrc.push({ pictureKey: key });
    }).catch(() => {
      AppStore.ShowError(`请上传正确格式的文件`);
    });
    self.Limit++;
    // request
    //   .get(`/api/System/QiNiuToken`)
    //   .then((res: any) => {
    //     this.token = res;
    //     let observer = {
    //       next(res: any) {},
    //       error(err: any) {
    //         console.log(err);
    //         self.Limit++;
    //         AppStore.ShowError(`请上传正确格式的文件`);
    //       },
    //       complete(res: any) {
    //         self.imgSrc.push({ pictureKey: res.key });
    //       }
    //     };
    //     var putExtra = {
    //       fname: '',
    //       params: {},
    //       mimeType: [] || null
    //     };
    //     var config = {
    //       useCdnDomain: true,
    //       region: undefined
    //     };
    //     var observable = Qiniu.upload(file, null, res, putExtra, config);
    //     var subscription = observable.subscribe(observer);
    //   })

  }

  delImg(index: any) {
    this.value.splice(index, 1);
    if (this.Limit !== undefined) this.Limit = this.limit - this.imgSrc.length;
  }
  firstImage(index: never) {
    if (index) {
      let first = this.imgSrc.splice(index, 1)[0];
      this.imgSrc.unshift(first);
    }
  }
  @Watch('value', { immediate: true, deep: true })
  onValueChange(newValue: any, oldValue: any) {
    this.imgSrc = newValue;
  }
}
